<template>
  <div id="app">
<!--
    <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div>
-->
    <meta name="viewport" content="width=device-width,initial-scale=1.0,user-scalable=no">
    <navbar v-show="$route.meta.showNav"></navbar>
    <iconMe v-show="$route.meta.showNav" class="myMsg"></iconMe>
    <!-- <mapIcon v-show="$route.meta.showNav"></mapIcon> -->
    <router-view v-if="isRouterAlive"/>
  </div>
</template>

<script>
export default {
        name: 'App',
        provide () {    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。                                             
            return {
                reload: this.reload                                              
            }
        },
        data() {
            return{
                isRouterAlive: true                    //控制视图是否显示的变量
            }
        },
        created(){ 
            // if(this.$router.path !== '/'){
            //     this.$router.replace('/')
            // }
			// this.$router.go(-1)
			console.log(this.$route)
        },
        methods: {
            reload () {
                this.isRouterAlive = false;            //先关闭，
                this.$nextTick(function () {
                    this.isRouterAlive = true;         //再打开
                })
            }
        }
    }
</script>

<style>
  *{
    padding: 0;
    margin: 0;
    font-size: 15px;
    /* font-family: Microsoft YaHei6; */
    font-family: "Microsoft YaHei", 微软雅黑, "MicrosoftJhengHei", 华文细黑, STHeiti, MingLiu;
  }
@media screen and(min-width: 320px)and(max-width: 359px){

}
@media screen and(min-width: 360px)and(max-width: 374px){

}
@media screen and(min-width: 375px)and(max-width: 385px){

}
@media screen and(min-width: 386px)and(max-width: 392px) {

}
@media screen and(min-width: 393px)and(max-width: 400px){

}
@media screen and(min-width: 401px)and(max-width: 414px){

}
@media screen and(min-width: 750px)and(max-width: 799px){

}

/* #app{ max-width: 760px; margin:auto; } */

</style>
